import { gql } from "@apollo/client"

import seoFields from "./partials/seoFields"
import sys from "./partials/sys"

export const legalPageID = "Legal"
export const legalCollection = "legalCollection"
// The GraphQL query
export const LEGAL_PAGE_QUERY = gql`
  query getLegalPage($slug: String!, $preview: Boolean!) {
    ${legalCollection}(
    where:{slug: $slug} 
    preview: $preview
    limit: 1
    ) {
      items {
        ${sys}
        title
        sections
        content {
          json
        }
        slug
        seo {
        ${seoFields}
        }   
      }
    }
  }
`
export const GET_ALL_LEGAL_SLUGS = gql`
  query getAllLegalSlugs {
    legalCollection {
      items {
        slug
      }
    }
  }
`
export const GET_ALL_LEGAL_SLUGS_AND_TITLES = gql`
  query getAllLegalSlugs {
    legalCollection {
      items {
        slug
        title
      }
    }
  }
`
